import React from 'react';

export function ChatbotIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M11.0968 8.15646C11.0968 8.71128 10.6402 9.16106 10.077 9.16106C9.51372 9.16106 9.05713 8.71128 9.05713 8.15646C9.05713 7.60163 9.51372 7.15186 10.077 7.15186C10.6402 7.15186 11.0968 7.60163 11.0968 8.15646Z"
        fill="white"
      />
      <path
        d="M14.4596 9.16106C15.0229 9.16106 15.4795 8.71128 15.4795 8.15646C15.4795 7.60163 15.0229 7.15186 14.4596 7.15186C13.8964 7.15186 13.4398 7.60163 13.4398 8.15646C13.4398 8.71128 13.8964 9.16106 14.4596 9.16106Z"
        fill="white"
      />
      <path
        d="M9.97181 11.3521C9.88207 11.2408 9.96478 11.0884 10.1091 11.0884H14.3893C14.5285 11.0884 14.6121 11.2317 14.532 11.3437C14.2129 11.79 13.4426 12.6648 12.3058 12.6648C11.176 12.6648 10.3333 11.8009 9.97181 11.3521Z"
        fill="white"
      />
      <path
        d="M6.47356 13.4973L6.46934 13.4909L7.56722 12.7567C8.61983 14.2462 10.3703 15.22 12.3495 15.22C15.5628 15.22 18.1731 12.6532 18.1731 9.48017C18.1731 6.30715 15.5628 3.74031 12.3495 3.74031C11.2521 3.74031 10.225 4.03969 9.34823 4.56036L8.2917 3.68323C9.44414 2.89957 10.842 2.44043 12.3495 2.44043C16.3011 2.44043 19.4991 5.59521 19.4991 9.48017C19.4991 13.3651 16.3011 16.5199 12.3495 16.5199C10.4701 16.5199 8.76098 15.8062 7.4851 14.6394L7.36277 14.5275L4.43699 16.4892L4.58736 16.6692C6.45463 18.9046 9.24159 20.2153 12.2059 20.2153C15.1009 20.2153 17.8103 18.9748 19.6743 16.8444C19.694 16.833 20.2056 16.195 20.3221 16.0069L21.4766 16.7479C21.4484 16.7901 21.3934 16.8617 21.3934 16.8617C19.2858 19.8094 15.8786 21.5585 12.2065 21.5587C8.47792 21.5585 5.00079 19.7412 2.90445 16.6992L2.52344 16.1455L6.47356 13.4973Z"
        fill="white"
      />
    </svg>
  );
}
